import React from 'react'
import { Col } from 'react-bootstrap';
import BreadcrumbItem from './BreadcrumbItem';

const Breadcrumb = ({ breadcrumbItems, currentStep }) => {
  return (
    <Col sm={12} className="d-none d-sm-block">
      <ul className="list-unstyled inline-steps">
        {breadcrumbItems.map((breadcrumbStep) => {
          if (!breadcrumbStep.hasOwnProperty('title') || !breadcrumbStep.title) return null
          return <BreadcrumbItem key={breadcrumbStep.title}  title={breadcrumbStep.title} isActive={breadcrumbStep.id === currentStep} />
        })}
      </ul>
    </Col>
  )
}

export default Breadcrumb
